
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Search from './pages/search';
import Login from './pages/login';
import Download from './pages/download';
function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Search />} />
      <Route path='/login' element={<Login />} />
      <Route path='/download' element={<Download />} />
    </Routes>
  </BrowserRouter>
  );
}

export default App;
